import axios from 'axios';
import { getJwtToken } from './jwt.services';
const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your API's base URL

const ObjectExplorerService = {
  getObject: async (companyId, objectType, objectId) => {

    const jwtToken = getJwtToken();
    let response;
    try {
      const apiUrl = `${BASE_URL}/object/${objectType}/${objectId}`;
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
      response = await axios.get(apiUrl, { headers, params: {companyId} }).catch((error) => {return {data: error.response}});
      return response.data;
    } catch (error) {
      console.log("ObjectExplorerService (ERROR): getObject ", error.message)
      throw error;
    }
  }
};




export default ObjectExplorerService;